/* Kivaro Steady PDP: scroll-fill timelines, decoder tabs, accordions, carousels, scroll-to-buy CTAs.
   Vanilla, no dependencies. Loaded with defer. Safe to include more than once. */
(function () {
  if (window.__kvPdp) return;
  window.__kvPdp = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll-fill timelines (§03, §08) ---------- */
  function initTimeline(root) {
    if (root.hasAttribute('data-kv-ready')) return;
    var fill = root.querySelector('.kv-tl__fill');
    var items = [].slice.call(root.querySelectorAll('.kv-tl__item'));
    var n = items.length;
    var inset = parseFloat(root.getAttribute('data-kv-inset')) || 28;
    var nudge = parseFloat(root.getAttribute('data-kv-nudge')) || 0.02;
    root.setAttribute('data-kv-ready', '');

    if (reduceMotion || !n || !fill) {
      if (fill) fill.style.height = 'calc(100% - ' + inset + 'px)';
      items.forEach(function (el) { el.classList.add('is-active'); });
      return;
    }

    var raf = 0;
    function update() {
      raf = 0;
      if (!root.isConnected) return;
      var r = root.getBoundingClientRect();
      var p = r.height ? Math.min(1, Math.max(0, (window.innerHeight * 0.6 - r.top) / r.height)) : 0;
      fill.style.height = 'calc(' + (p * 100).toFixed(2) + '% - ' + (p * inset).toFixed(2) + 'px)';
      items.forEach(function (el, i) { el.classList.toggle('is-active', p >= i / n + nudge); });
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(update); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ---------- accordions (§02, §11): one open per group ---------- */
  function initAccordion(group) {
    if (group.hasAttribute('data-kv-ready')) return;
    group.setAttribute('data-kv-ready', '');
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.kv-acc__btn');
      if (!btn || !group.contains(btn)) return;
      var open = btn.getAttribute('aria-expanded') !== 'true';
      [].forEach.call(group.querySelectorAll('.kv-acc__btn'), function (b) {
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        var on = b === btn && open;
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (panel) panel.hidden = !on;
      });
    });
  }

  /* ---------- tabs (§06) ---------- */
  function initTabs(root) {
    if (root.hasAttribute('data-kv-ready')) return;
    root.setAttribute('data-kv-ready', '');
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
  }

  /* ---------- carousels: reviews (§10) and gallery (§02) ---------- */
  function initCarousel(root) {
    if (root.hasAttribute('data-kv-ready')) return;
    root.setAttribute('data-kv-ready', '');
    var track = root.querySelector('[data-kv-track]');
    if (!track) return;
    var behavior = reduceMotion ? 'auto' : 'smooth';
    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-kv-dir]');
      if (!btn || !root.contains(btn)) return;
      var dir = btn.getAttribute('data-kv-dir') === 'next' ? 1 : -1;
      var max = track.scrollWidth - track.clientWidth;
      // gallery wraps around at the ends
      if (root.hasAttribute('data-kv-wrap')) {
        if (dir > 0 && track.scrollLeft >= max - 2) return track.scrollTo({ left: 0, behavior: behavior });
        if (dir < 0 && track.scrollLeft <= 2) return track.scrollTo({ left: max, behavior: behavior });
      }
      track.scrollBy({ left: dir * step(), behavior: behavior });
    });

    // gallery thumbnails
    var thumbs = [].slice.call(root.querySelectorAll('[data-kv-thumb]'));
    if (!thumbs.length) return;
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: i * track.clientWidth, behavior: behavior });
      });
    });
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
        thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      });
    }, { passive: true });
  }

  /* ---------- CTAs scroll to the Kaching block (#kv-buy) ---------- */
  // Height of whatever is pinned to the top of the viewport (sticky/fixed header, announcement bar).
  // Theme-agnostic: checks the elements sitting at the top edge instead of theme-specific selectors.
  function headerOffset() {
    var bottom = 0, seen = [];
    [0.15, 0.5, 0.85].forEach(function (fx) {
      var el = document.elementFromPoint(window.innerWidth * fx, 2);
      while (el && el !== document.body && el !== document.documentElement) {
        if (seen.indexOf(el) === -1) {
          seen.push(el);
          var pos = getComputedStyle(el).position;
          if (pos === 'sticky' || pos === 'fixed') bottom = Math.max(bottom, el.getBoundingClientRect().bottom);
        }
        el = el.parentElement;
      }
    });
    return Math.min(bottom, window.innerHeight * 0.4) + 16;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#kv-buy"], [data-kv-scroll]');
    if (!a) return;
    var id = (a.getAttribute('data-kv-scroll') || a.getAttribute('href') || '#kv-buy').slice(1);
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  /* ---------- boot + theme editor support ---------- */
  function init(scope) {
    scope = scope || document;
    [].forEach.call(scope.querySelectorAll('[data-kv-timeline]'), initTimeline);
    [].forEach.call(scope.querySelectorAll('[data-kv-accordion]'), initAccordion);
    [].forEach.call(scope.querySelectorAll('[data-kv-tabs]'), initTabs);
    [].forEach.call(scope.querySelectorAll('[data-kv-carousel]'), initCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest && e.target.closest('[role="tab"]');
    if (tab) tab.click();
    var acc = e.target.querySelector && e.target.querySelector('.kv-acc__btn[aria-expanded="false"]');
    if (acc) acc.click();
  });
})();
